import React, { useState, useEffect, useCallback } from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";
import axios from "../../utils/axios";
import Swal from "sweetalert2";
import { getToken } from "../../utils/Common";
import HEAD from "../../component/header";
import SIDE from "../../component/navbar";
import DataTable from "react-data-table-component";
import Moment from "moment";
import _ from "lodash";

function PurchaseOrderDaily() {
  const token = getToken();
  const headers = {
    Authorization: `Bearer ${token}`,
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
  };
  const history = useHistory();
  const FileDownload = require("js-file-download");
  // Session
  const session = localStorage.getItem("user");
  const udeptID = JSON.parse(session).dept_id;
  const hcode = JSON.parse(session).hotel_id;

  // Var
  const [PurchaseOrder, setPurchaseOrder] = useState([]);

  const params = useParams();
  const groupID = params.HOTELGROUP;

  const getListPODaily = () => {
    if (groupID == 1) {
      axios
        .get("/api/waiting/purchase/order/group1", { headers: headers })
        .then(function (response) {
          console.log(response.data);
          setPurchaseRequest(
            Object.values(response.data).flatMap((arr) => arr)
          );
        })
        .catch(function (error) {
          console.log(error);
        });
    }

    if (groupID == 2) {
      axios
        .get("/api/waiting/purchase/order/group2", { headers: headers })
        .then(function (response) {
          console.log(response.data);
          setPurchaseRequest(
            Object.values(response.data).flatMap((arr) => arr)
          );
        })
        .catch(function (error) {
          console.log(error);
        });
    }

    if (groupID == 3) {
      axios
        .get("/api/waiting/purchase/order/group3", { headers: headers })
        .then(function (response) {
          console.log(response.data);
          setPurchaseRequest(
            Object.values(response.data).flatMap((arr) => arr)
          );
        })
        .catch(function (error) {
          console.log(error);
        });
    }

    if (groupID == 4) {
      axios
        .get("/api/waiting/purchase/order/group4", { headers: headers })
        .then(function (response) {
          console.log(response.data);
          setPurchaseRequest(
            Object.values(response.data).flatMap((arr) => arr)
          );
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  };

  const [purchaseRequest, setPurchaseRequest] = useState([]);
  const [hotelList, setHotelList] = useState([]);

  const columns = [
    {
      name: "PR No.",
      width: "200px",
      wrap: true,
      selector: (row) => row.nomer,
    },
    {
      name: "Status",
      wrap: true,
      selector: (row) => row.need,
    },
    {
      name: "Origin",
      wrap: true,
      cell: (row) => (
        <div>
          <b>For Hotel</b> : {row.nm_hotel}
          <br />
          <b>From Department: </b> {row.nm_department}
        </div>
      ),
    },
    {
      name: "Remark",
      wrap: true,
      cell: (row) => (
        <div
          style={{
            paddingTop: "10px",
            paddingBottom: "10px",
            color: "#580C30",
          }}
        >
          {row.remark}
        </div>
      ),
    },
    {
      name: " Need For",
      cell: (row) => Moment(row.date_need).format("LL"),
    },
    {
      name: "Status",
      wrap: true,
      cell: (row) => (
        <>
          <i>Waiting Purchasing to Generated PO</i>
        </>
      ),
    },
    {
      name: "",
      width: "50px",
      cell: (row) => (
        <div onClick={() => history.push(`/detail/proposal/${row.id_pp}`)}>
          <i class="bi bi-search"></i>
        </div>
      ),
    },
  ];

  // Search
  const [filtertext, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const filteredItems = purchaseRequest.filter((search) =>
    Object.values(search)
      .join("")
      .toLowerCase()
      .includes(filtertext.toLowerCase())
  );

  const handleClear = () => {
    if (filtertext) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  };

  const debouncedGetListPODaily = _.debounce(getListPODaily, 100);

  // useEffect with debounced function
  useEffect(() => {
    debouncedGetListPODaily();
    //console.log(groupID); // Assuming groupID is declared somewhere accessible in this scope
  }, []);

  return (
    <>
      <HEAD />
      <SIDE />

      <main id="main" class="main">
        <div className="pagetitle">
          <h1>Purchase Order</h1>
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">Purchase Order</li>
              <li className="breadcrumb-item active">Today</li>
            </ol>
          </nav>
        </div>

        <section>
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <div className="card-title">
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-primary"
                      style={{ marginRight: "1%" }}
                      onClick={() => debouncedGetListPODaily()}
                    >
                      <i className="bi bi-arrow-clockwise"></i>
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-primary"
                      style={{ marginRight: "1%" }}
                    >
                      <i className="bi bi-printer"></i>
                    </button>
                  </div>
                  <div className="row mt-4">
                    <div className="col-12">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search"
                        onChange={(e) => setFilterText(e.target.value)}
                        onClear={() => handleClear}
                        filtertext={filtertext}
                      />
                    </div>
                  </div>

                  <div className="row">
                    <DataTable
                      columns={columns}
                      data={filteredItems}
                      fixedHeader
                      fixedHeaderScrollHeight="440px"
                      pagination
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default PurchaseOrderDaily;
